import { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { formatPlaceholder } from '../../../../lib/utils';
import Label from '../../../../ui/primitives/Label';

const TestCaseDetailsComponent = ({ testCase, projectId, labels = [] }) => {
  const labelNames = useMemo(() => {
    if (!testCase?.labels?.length || !labels.length) return [];
    return labels
      .filter((label) => testCase.labels.includes(label.id))
      .map((label) => label.name);
  }, [testCase?.labels, labels]);

  if (!testCase) {
    return (
      <div className="text-center text-muted">
        Test case details not available
      </div>
    );
  }

  return testCase ? (
    <Container fluid>
      <Row>
        <Col>
          <p className="form-label mb-1">Description</p>
          <p title={testCase.summary} className="mb-0 text-wrap">
            {testCase.summary}
          </p>
        </Col>
        <Col>
          <p className="form-label mb-1">Objective</p>
          <p className="mb-0 text-wrap">
            {testCase.objective || formatPlaceholder()}
          </p>
        </Col>
        <Col>
          <p className="form-label mb-1">Precondition</p>
          <p className="mb-0 text-wrap">
            {testCase.pre_condition || formatPlaceholder()}
          </p>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={4}>
          <p className="form-label mb-1">Status</p>
          <Label
            color={testCase.status_details?.color || '#6c757d'}
            name={testCase.status_details?.name || 'Unknown'}
          />
        </Col>
        <Col md={4}>
          <p className="form-label mb-1">Priority</p>
          <Label
            color={testCase.priority_details?.color || '#6c757d'}
            name={testCase.priority_details?.name || 'Unknown'}
          />
        </Col>
        <Col md={4}>
          <p className="form-label mb-1">Labels</p>
          <p className="rounded text-dark">
            {labelNames.length ? labelNames.join(', ') : 'None'}
          </p>
        </Col>
      </Row>
    </Container>
  ) : (
    <div className="text-center text-muted">
      Test case details not available
    </div>
  );
};

export default TestCaseDetailsComponent;
